import type { NestedI18nObject } from '../../utils';

const common: NestedI18nObject = {
  // 布局
  layouts: {
    userLayout: {
      title: 'Ant Design 是西湖区最具影响力的 Web 设计规范',
    },
  },

  // 登录页面
  login: {
    accountLogin: {
      tab: '账户密码登录',
      errorMessage: '错误的用户名和密码(admin/ant.design)',
    },
    failure: '登录失败，请重试！',
    success: '登录成功！',
    username: {
      placeholder: '用户名: admin or user',
      required: '用户名是必填项！',
    },
    password: {
      placeholder: '密码: ant.design',
      required: '密码是必填项！',
    },
    phoneLogin: {
      tab: '手机号登录',
      errorMessage: '验证码错误',
      getVerificationCode: '获取验证码',
    },
    phoneNumber: {
      placeholder: '请输入手机号！',
      required: '手机号是必填项！',
      invalid: '不合法的手机号！',
    },
    captcha: {
      placeholder: '请输入验证码！',
      required: '验证码是必填项！',
    },
    rememberMe: '自动登录',
    forgotPassword: '忘记密码 ?',
    submit: '登录',
    loginWith: '其他登录方式 :',
    registerAccount: '注册账户',
  },

  // 通用验证码文本
  getCaptchaSecondText: '秒后重新获取',

  // 欢迎页面
  welcome: {
    link: '欢迎使用',
    alertMessage: '更快更强的重型组件，已经发布。',
  },

  // 404页面
  '404': {
    subTitle: '抱歉，您访问的页面不存在。',
    buttonText: '返回首页',
  },
};

export default common;
